import { supabase } from '@/lib/supabase';

export type ManageOrgInvitationInput = {
  invitationToken: string;
  status: 'accepted' | 'declined';
};

export const manageOrgInvitation = async ({
  invitationToken,
  status,
}: ManageOrgInvitationInput) => {
  const { data, error } = await supabase.rpc('manage_org_invitation', {
    p_invitation_token: invitationToken,
    p_invitation_status: status,
  });

  if (error) {
    throw error;
  }

  return data;
};
